var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('strong',[_vm._v("Importante!")]),_vm._v(" Sua assinatura está expirada. ")])}]

export { render, staticRenderFns }